// extracted by mini-css-extract-plugin
export default {"card":"HoursCard_card__KlI+j","notice":"HoursCard_notice__6O-D6"};